{
  "permissions": {
    "noPermission": "Você não tem permissão para realizar esta ação",
    "viewOnly": "Exibir somente"
  },
  "importFinished": "A importação foi concluída",
  "switchLevel": "Nível do interruptor",
  "removeFilter": "Remover filtro",
  "styleByProperty": "Defina as dimensões do modelo usando os valores das propriedades dos itens da lista",
  "styleByPropertyTooltip": "Quando ativado, o tamanho dos modelos nessa camada será determinado usando as dimensões da tabela de itens da lista. Os itens da sua lista devem conter colunas numéricas adicionais para 'Largura', 'Comprimento' e 'Altura' para usar essa opção. Para obter instruções detalhadas, consulte nosso",
  "styleByPropertyTooltipLink": "artigo da base de conhecimento",
  "copy": {
    "copyTo": "Copiar para este local",
    "setTo": "Definir nova localização",
    "tooltip": {
      "Map": "Não é possível copiar em um plano",
      "Layer": "Não é possível copiar em uma camada"
    }
  },
  "digitalTwin": {
    "cameraModes": {
      "orbit": "Câmera Orbit",
      "walk": "Caminhe",
      "fly": "Câmera Fly"
    }
  },
  "venue_bookmark": "Marcador de local",
  "venue_bookmark_form": {
    "save": "Salvar marcador",
    "name": "Nome"
  },
  "venue_bookmark_view": {
    "bookmarks": "Favoritos",
    "delete_bookmark": "Excluir marcador",
    "create_bookmark": "Criar marcador a partir da visualização atual",
    "no_bookmarks": "Sem marcadores"
  },
  "venue_bookmark_no_venue_error": {
    "title": "Não é possível criar um marcador",
    "message": "Você não pode criar um marcador fora de um local"
  },
  "venue_bookmark_creation_error": {
    "title": "Não é possível criar um marcador",
    "message": "Houve um erro ao criar o marcador. Por favor, tente novamente mais tarde."
  },
  "controls": {
    "toggle_street_names": "Nomes de ruas e lugares",
    "disabled_terrain_sitemap_3d": "O terreno não pode ser ativado quando um mapa do site 3D está em exibição",
    "disabled_3d_buildings_sitemap_3d": "Edifícios 3D não podem ser ativados quando um mapa do site 3D está em exibição"
  },
  "modelPreview": {
    "front_view": "Vista frontal",
    "front_left_view": "Vista frontal esquerda",
    "capture_thumbnail": "Capturar miniatura",
    "preview_info_heading": "Verifique a pré-visualização e ajuste o modelo, se necessário, garantindo:",
    "preview_info_model_appears": "O modelo aparece na pré-visualização conforme o esperado",
    "preview_info_centered": "O centro do modelo se cruza com a linha azul",
    "preview_info_orientation": "O modelo está orientado corretamente e está voltado para frente ao ser visualizado de frente",
    "model_not_supported_error": "O modelo não é suportado, tente usar um arquivo diferente ou entre em contato com o suporte."
  },
  "modelShowThumbnailUploader": "ou fazer upload de um arquivo",
  "not_support_custom_colour": "O modelo que você enviou não suporta cores personalizadas. Para ver como habilitar isso, leia o artigo ",
  "areaModel": {
    "distribution": {
      "title": "Distribuição",
      "random": "Aleatório",
      "uniform": "Uniforme"
    },
    "rotation": {
      "title": "Rotação",
      "random": "Aleatório",
      "uniform": "Uniforme"
    }
  },
  "systemDataFieldNames": {
    "MapObjectName": "Nome do objeto de mapa",
    "MapObjectArea": "Área",
    "MapObjectLength": "Comprimento",
    "Coordinates": "Coordenadas",
    "RouteTime": "Tempo de rota",
    "QuantityOfModelsOnLine": "Quantidade",
    "QuantityOfModelsInArea": "Quantidade",
    "RotationZOfModelsInArea": "Rotação",
    "IconRotation": "Rotação",
    "ModelAltitude": "Altitude"
  },
  "dateTimeFilter": {
    "newObjectFilteredTitle": "Objeto de mapa filtrado",
    "newObjectFilteredBody": "O objeto de mapa recém-criado foi filtrado pelo filtro de data e hora"
  },
  "sitemapVersion": {
    "twoDimensional": "2D",
    "threeDimensional": "3D"
  },
  "shareMap": {
    "copyNotification": "O link do mapa compartilhado foi copiado para sua área de transferência",
    "useDescription": "Os links compartilhados são projetados para uso privado somente com indivíduos específicos.",
    "warning": "A publicação pública ou a distribuição em massa (por exemplo, em sites, mídias sociais ou listas de e-mail) não são permitidas. Para saber mais sobre como compartilhar planos publicamente, entre em contato com support@iventis.com.",
    "customSharedLinkDuration": {
      "description": "Defina a duração do link:",
      "duration": {
        "ThreeDays": "3 dias",
        "SevenDays": "7 dias",
        "FourteenDays": "14 dias",
        "ThirtyDays": "30 dias"
      },
      "contactSupport": "Se você precisar fornecer acesso por mais de 30 dias, entre em contato com support@iventis.com para discutir suas necessidades."
    }
  },
  "screenshot": {
    "take_screenshot": "Faça uma captura de tela",
    "screenshot": "Captura de tela",
    "copiedToClipboardToast": {
      "title": "Captura de tela copiada para a área de transferência",
      "message": "Agora você pode colá-lo em outro aplicativo"
    },
    "downloadedImageToast": {
      "title": "Captura de tela baixada",
      "message": "Você pode encontrá-lo na sua pasta de downloads"
    },
    "errorToast": {
      "title": "Algo deu errado",
      "message": "Não foi possível fazer a captura de tela, tente novamente"
    }
  },
  "style": {
    "altitude": "Altitude"
  }
}